import { render, staticRenderFns } from "./MisionVisionValores.vue?vue&type=template&id=183d0b8c&scoped=true&"
import script from "./MisionVisionValores.vue?vue&type=script&lang=js&"
export * from "./MisionVisionValores.vue?vue&type=script&lang=js&"
import style0 from "./MisionVisionValores.vue?vue&type=style&index=0&id=183d0b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d0b8c",
  null
  
)

export default component.exports